module.exports = __webpack_public_path__ + "static/media/node-4.c5f9d930.svg";